import React from "react";
import { Chip, styled } from "@mui/material";
import type { PathwayRecommendation } from "../../types";

const MustTryChip = styled(Chip, {
  label: "MustTryChip",
})(() => ({
  color: "#fff",
  fontFamily: "Proxima Nova, sans-serif",
  fontWeight: 700,
  fontSize: "13px",
  backgroundColor: "#ea1d76",
}));

const MightLikeChip = styled(Chip, {
  label: "MightLikeChip",
})(() => ({
  color: "#fff",
  fontFamily: "Proxima Nova, sans-serif",
  fontWeight: 700,
  fontSize: "13px",
  backgroundColor: "#098dee",
}));

export const RecommendationChip = ({
  recommendation,
}: {
  recommendation: PathwayRecommendation | undefined | null;
}) => {
  if (recommendation === "must-try") {
    return <MustTryChip label="Must Try" size="small" />;
  }
  if (recommendation === "might-like") {
    return <MightLikeChip label="Might Like" size="small" />;
  }
  return null;
};
